const StatusIndicator = ({ status, showLabel = false }) => {
	const getStatusColor = (status) => {
		switch (status) {
			case "toUpload":
				return "#808080"; // Gray
			case "approved":
				return "#4CAF50"; // Green
			case "toApprove":
				return "#FFC107"; // Yellow
			case "rejectedDone":
				return "#2196F3"; // Blue
			case "rejected":
				return "#F44336"; // Red
			case "expired":
				return "#F44336"; // Red
			default:
				return "transparent"; // No color for null or unknown status
		}
	};

	const getStatusLabel = (status) => {
		if (status === "expired") {
			return "Documento scaduto";
		}
		return null;
	};

	if (status === null) {
		return null;
	}

	const color = getStatusColor(status);
	const darkerColor = color === "transparent" ? "transparent" : color.replace(/[^,]+(?=\))/, "0.7"); // Creates a darker version for gradient
	const label = getStatusLabel(status);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
			}}
		>
			<div
				style={{
					position: "relative",
					width: "20px",
					height: "20px",
					margin: "2px",
				}}
			>
				<div
					style={{
						width: "100%",
						height: "100%",
						borderRadius: "50%",
						background: `radial-gradient(circle at 30% 30%, ${color}, ${darkerColor})`,
						// boxShadow: `
						//   inset 0 0 8px rgba(0,0,0,0.3),
						//   0 0 16px ${color}
						// `,
						border: `1px solid rgba(255,255,255,0.2)`,
						position: "relative",
					}}
				>
					{/* Light reflection effect */}
					<div
						style={{
							position: "absolute",
							width: "35%",
							height: "35%",
							borderRadius: "50%",
							background: "rgba(255,255,255,0.3)",
							top: "20%",
							left: "20%",
							transform: "rotate(45deg)",
						}}
					/>
				</div>
			</div>
			{label && (
				<span
					style={{
						fontSize: "10px",
						color: "#F44336",
						marginTop: "4px",
						whiteSpace: "",
						textWrap: "wrap",
						textAlign: "center",
					}}
				>
					{label}
				</span>
			)}
		</div>
	);
};

export default StatusIndicator;
